import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { createStyles, withStyles } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import Icon from '../../../core/Icon';

var styles = function styles(theme) {
  return createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      minHeight: '100%'
    }
  });
};
/**@param {import('./types').RatingProps & import('@material-ui/core').WithStyles<typeof styles>} props */


var RatingField = function RatingField(_ref) {
  var readOnly = _ref.readOnly,
      disabled = _ref.disabled,
      name = _ref.name,
      iconType = _ref.iconType,
      rest = _objectWithoutProperties(_ref, ["readOnly", "disabled", "name", "iconType"]);

  var iconContainerComponent = undefined;

  switch (iconType) {
    case 'star':
      iconType = ':favorites';
      break;

    case 'bulb':
      iconType = 'light-bulb';
      break;

    case 'heart':
      iconType = 'heart';
      break;

    case 'thumb':
      iconType = 'thumbs-up';
      break;

    default:
      break;
  }

  if (iconType) iconContainerComponent = function iconContainerComponent(_ref2) {
    var value = _ref2.value,
        other = _objectWithoutProperties(_ref2, ["value"]);

    return React.createElement("span", other, iconType && React.createElement(Icon, {
      type: iconType,
      style: {
        fontSize: '1.25rem',
        width: '1.5rem'
      }
    }));
  };
  return React.createElement(Rating, Object.assign({}, rest, {
    readOnly: !!readOnly,
    name: name,
    disabled: !!disabled,
    IconContainerComponent: iconContainerComponent
  }));
};
/**@type {Partial<import('./types').RatingProps>} */


RatingField.defaultProps = {};
export default withStyles(styles, {
  name: 'ECRatingField'
})(RatingField);